import { render } from "./BacardiSales.vue?vue&type=template&id=27f8321d"
import script from "./BacardiSales.vue?vue&type=script&lang=js"
export * from "./BacardiSales.vue?vue&type=script&lang=js"

import exportComponent from "/media/alvian/New Volume/project/vue js/sample-inc-web-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__